import { Action, ActionType } from "models/changePassword";
import { IResponse } from "models";

import createReducer from "redux/createReducer";

export interface ChangePasswordReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  changePasswordResponse?: IResponse;
}

const defaultState: ChangePasswordReducerType = {
  loading: false,
  error: null,
  saved: false,
  changePasswordResponse: undefined,
};

export const changePasswordReducer = createReducer<ChangePasswordReducerType>(
  defaultState,
  {
    [ActionType.CHANGE_PASSWORD](state: ChangePasswordReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.CHANGE_PASSWORD_ERROR](
      state: ChangePasswordReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.CHANGE_PASSWORD_SUCCESS](
      state: ChangePasswordReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        changePasswordResponse: action.payload,
      };
    },

    [ActionType.RESET_CHANGE_PASSWORD](state: ChangePasswordReducerType) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: null,
        changePasswordResponse: undefined,
      };
    },
  }
);
